var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemrushPinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 11.886h-1.3l-.5-4.92h.554a.605.605 0 00.434-.176.636.636 0 00.187-.439v-2.46a.636.636 0 00-.188-.44.605.605 0 00-.437-.175h-6.25a.605.605 0 00-.437.175.636.636 0 00-.188.44v2.46a.636.636 0 00.188.44.605.605 0 00.437.175h.554l-.5 4.92H7.625a.605.605 0 00-.437.175.636.636 0 00-.188.44v2.46a.636.636 0 00.188.44.605.605 0 00.437.175h8.75c.162.003.32-.06.437-.175a.636.636 0 00.188-.44v-2.46a.636.636 0 00-.188-.44.605.605 0 00-.437-.175zM11.4 16.805v4.305c0 .163.063.32.176.435a.593.593 0 00.848 0 .623.623 0 00.176-.435v-4.305h-1.2z"
  })));
}
export default SvgSemrushPinIcon;